import { Button } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { configAPI } from "utils/api";
import { addMerchantConfig, addRmsConfig } from "features/config/configSlice";
import {
  getEncipherencode,
  sanitizeEncipherencode,
} from "utils/encipherencode";

function MaintenancePage({ setLoginLoader, setLoadConfigurations }) {
  const [params] = useSearchParams();
  const dispatch = useDispatch();

  const cname = window.location.hostname;

  const encipherencode = getEncipherencode(params);

  const navigate = useNavigate();

  const reload = () => {
    const code =
      encipherencode ||
      (cname === "localhost"
        ? "gAAAAABmhl81_N038e-lfPa1zKoaIhpAyHCuCb17QzbP4W5NBHy9noZnuBcs8QxE0L28hiFclPIkTjMiZIQ3T7yAwSOE0-iwtA=="
        : null);
    if (!code) {
      navigate("/error");
      return;
    }
    configAPI(code, cname !== "localhost" && !encipherencode ? cname : null)
      .then((resp) => {
        if (resp.data.under_maintenance) {
          navigate("/maintenance");
        } else {
          setLoadConfigurations(false);
          setLoginLoader(false);
          dispatch(addRmsConfig(resp.data.rms_config));
          dispatch(addMerchantConfig(resp.data.merchant_config));
          navigate(`/?encipherencode=${encipherencode}`);
        }
      })
      .catch((err) => {
        // console.log(err);
        navigate("/error");
      })
      .finally(() => {
        try {
          const validCode = sanitizeEncipherencode(
            cname !== "localhost"
              ? encipherencode
              : "gAAAAABlYOUldB0g5Yh6vD2Wq5jrFUWPifS8_DhQAuGA_nKPlmw2cL6z9YPEEYcGiI_eDfvbS9h7b2RUPXognGgjvzNfop7WHQ=="
          );
          if (validCode) {
            sessionStorage.setItem("encipherencode", validCode);
          }
        } catch {}
      });
  };

  return (
    <div
      style={{
        height: "90vh",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        flexDirection: "column",
        textAlign: "center",
        width: "100%",
      }}
    >
      <img src="/maintenance.png" style={{ width: "25%", margin: "0 auto" }} />
      <p style={{ fontWeight: "700", fontSize: "36px", marginTop: "0px" }}>
        Under Maintenance
      </p>
      <p style={{ color: "#4d4d4d", marginTop: "30px", fontSize: "20px" }}>
        The page you are looking for is under maintanence from 3am to 7am.
      </p>
      {/* <p style={{ color: "#4d4d4d", marginTop: "5px", fontSize: "20px" }}>
        Please try again after sometime
      </p> */}
      <Button
        type="submit"
        variant="contained"
        color="primary"
        style={{
          width: "300px",
          borderRadius: "0px",
          padding: "10px",
          fontSize: "18px",
          fontWeight: "600",
          display: "block",
          margin: "30px auto",
        }}
        onClick={() => reload()}
      >
        Try again
      </Button>
    </div>
  );
}

export default MaintenancePage;
